var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-text-search",
    d: "m12 20.25h-6c-1.577 0-2.25-.673-2.25-2.25v-12c0-1.577.673-2.25 2.25-2.25h5.25v2.25a3.383 3.383 0 0 0 3.75 3.75h2.25v2.25a.75.75 0 0 0 1.5 0v-3a.747.747 0 0 0 -.22-.53l-6-6a.747.747 0 0 0 -.53-.22h-6a3.383 3.383 0 0 0 -3.75 3.75v12a3.383 3.383 0 0 0 3.75 3.75h6a.75.75 0 0 0 0-1.5zm.75-14.25v-1.189l3.439 3.439h-1.189c-1.577 0-2.25-.673-2.25-2.25zm1.25 6.75h-7a.75.75 0 0 1 0-1.5h7a.75.75 0 0 1 0 1.5zm-7 4a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 0 1.5zm15.53 4.72-1.55-1.55a3.632 3.632 0 0 0 .6-2 3.68 3.68 0 1 0 -1.663 3.064l1.55 1.549a.75.75 0 0 0 1.06-1.06zm-6.78-3.553a2.167 2.167 0 1 1 2.167 2.166 2.169 2.169 0 0 1 -2.167-2.166z",
    fill: "rgb(0,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.a8fc1c1a0894ef6da74d5b43c99eddf3.svg";
export { ForwardRef as ReactComponent };